import React from "react";
import { useOutletContext } from "react-router-dom";
import { Box, Alert } from "@mui/material";
import { OnboardingFormSection } from "../Clients/OnboardingFormSection";
import { useAuth } from "../../components/contexts/AuthContext";
import SuccessPopup from "../../components/SuccessPopup";

export function Onboarding() {
  const { user: currentUser } = useAuth();
  const { setPageContext, onboardingRefreshKey, selectedFilter } = useOutletContext();

  const [notification, setNotification] = React.useState({
    open: false,
    message: "",
    isError: false,
  });

  React.useEffect(() => {
    setPageContext({
      title: "Mi Información",
      subtitle: "Revisa la información de tu empresa",
      showTitle: true,
      rightContent: null,
    });
  }, [setPageContext]);

  React.useEffect(() => {
    if (!notification.open) return;
    const timer = setTimeout(
      () => setNotification((prev) => ({ ...prev, open: false })),
      4000
    );
    return () => clearTimeout(timer);
  }, [notification.open]);

  const clientId = currentUser?.client;

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      gap: 2,
      height: { xs: "auto", md: "100%" },
      maxHeight: { xs: "none", md: "calc(100vh - 275px)" },
      pb: { xs: "80px", md: 0 }
    }}>
      {!clientId ? (
        <Alert severity="error">
          No se encontró el cliente asociado a tu cuenta. Contacta con soporte para
          completar tu onboarding.
        </Alert>
      ) : (
        <>
          <OnboardingFormSection
            clientId={clientId}
            selectedFilter={selectedFilter}
            refreshKey={onboardingRefreshKey}
            onSuccess={(message) =>
              setNotification({ open: true, message, isError: false })
            }
            onError={(message) =>
              setNotification({ open: true, message, isError: true })
            }
          />
          <SuccessPopup
            message={notification.message}
            isOpen={notification.open}
            onClose={() =>
              setNotification({ open: false, message: "", isError: false })
            }
            error={notification.isError}
            autoHideDuration={notification.isError ? 4000 : undefined}
          />
        </>
      )}
    </Box>
  );
}
